import React, {useEffect} from 'react'
import ClickOutside from 'react-click-outside'
import ReactDOM from 'react-dom'
import SuspenseLoading from '@components/SuspenseLoading'
import useKeyboardEvent from '@hooks/useKeyboardEvent'
import dynamic from 'next/dynamic'
import {useTranslation} from 'next-i18next'

import styles from './styles.module.css'

const Register = dynamic(() => import('@page-components/Auth/CodeLogin/Register'), {
  loading: SuspenseLoading
})

export interface RegisterModalProps {
  changeEmail: () => void
  email: string
  onSuccess: (session: {token: string; refreshToken: any}) => void
  close: () => void
}

function ModalInner(props: RegisterModalProps) {
  const {changeEmail, email, onSuccess, close} = props
  const {t} = useTranslation('auth')
  useEffect(() => {
    document.body.style.overflow = 'hidden'
    return () => {
      document.body.style.overflow = 'unset'
    }
  }, [])

  useKeyboardEvent('Escape', close)

  return (
    <div className={styles.container}>
      <ClickOutside onClickOutside={close}>
        <div className={styles.modalInner}>
          <div className={styles.header}>
            <h1>{t('myContactInfo')}</h1>
            <p>{t('myContactInfoDescription')}.</p>
          </div>
          <div className={styles.divider}></div>
          <Register changeEmail={changeEmail} email={email} onSuccess={onSuccess} isCheckout />
        </div>
      </ClickOutside>
    </div>
  )
}

export default function Modal(props: RegisterModalProps) {
  return ReactDOM.createPortal(<ModalInner {...props} />, document.querySelector('#modal-root'))
}
